/* ==========================================================================
   JAFS theme — front-end behaviour
   No dependencies. Uses the Shopify AJAX Cart API.
   ========================================================================== */
(function () {
  'use strict';

  var routes = window.themeRoutes || {};
  var strings = window.themeStrings || {};
  var moneyFormat = window.themeMoneyFormat || '{{amount_with_space_separator}} kr';

  /* ---------- helpers ---------- */

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /*
    Money formatting must understand every placeholder Shopify supports.
    The shop is set to {{amount_with_space_separator}} kr — if the formatter
    does not know that name it prints the placeholder itself on the page.
  */
  function formatMoney(cents) {
    var amount = Number(cents) / 100;
    if (isNaN(amount)) amount = 0;

    function build(decimals, thousandsSep, decimalSep) {
      var fixed = Math.abs(amount).toFixed(decimals);
      var parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);
      var out = parts.length > 1 ? parts[0] + decimalSep + parts[1] : parts[0];
      return (amount < 0 ? '-' : '') + out;
    }

    return String(moneyFormat)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, build(0, '.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g, build(0, ' ', ','))
      .replace(/\{\{\s*amount_with_period_and_space_separator\s*\}\}/g, build(2, ' ', '.'))
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, build(2, "'", '.'))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, build(2, '.', ','))
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, build(2, ' ', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, build(0, ',', '.'))
      .replace(/\{\{\s*amount\s*\}\}/g, build(2, ',', '.'));
  }

  function fetchJSON(url, options) {
    return fetch(url, options).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw data;
        return data;
      });
    });
  }

  /* ---------- toast ---------- */

  var toastEl;
  var toastTimer;
  function toast(message) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = message;
    requestAnimationFrame(function () { toastEl.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
  }

  /* ---------- cart drawer ---------- */

  var Drawer = {
    el: null,
    overlay: null,
    lastFocus: null,

    init: function () {
      Drawer.el = $('[data-cart-drawer]');
      Drawer.overlay = $('[data-drawer-overlay]');
      if (!Drawer.el) return;

      $$('[data-cart-open]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          Drawer.open();
        });
      });

      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-cart-close]') || e.target === Drawer.overlay) {
          Drawer.close();
        }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && Drawer.el.classList.contains('is-open')) Drawer.close();
      });

      /* quantity + remove inside the drawer */
      Drawer.el.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-line-change]');
        if (!btn) return;
        e.preventDefault();
        var line = btn.getAttribute('data-line');
        var qty = parseInt(btn.getAttribute('data-qty'), 10);
        Cart.change(line, qty);
      });
    },

    open: function () {
      if (!Drawer.el) return;
      Drawer.lastFocus = document.activeElement;
      Drawer.el.classList.add('is-open');
      Drawer.el.removeAttribute('aria-hidden');
      if (Drawer.overlay) Drawer.overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      var close = $('[data-cart-close]', Drawer.el);
      if (close) close.focus();
    },

    close: function () {
      if (!Drawer.el) return;
      Drawer.el.classList.remove('is-open');
      Drawer.el.setAttribute('aria-hidden', 'true');
      if (Drawer.overlay) Drawer.overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      if (Drawer.lastFocus) Drawer.lastFocus.focus();
    }
  };

  /* ---------- cart ---------- */

  var Cart = {
    add: function (items, opts) {
      opts = opts || {};
      return fetchJSON((routes.cartAdd || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function () {
          return Cart.refresh();
        })
        .then(function (cart) {
          if (opts.openDrawer !== false) Drawer.open();
          else toast(strings.added || 'Lagt i kurven');
          return cart;
        })
        .catch(function (err) {
          toast((err && (err.description || err.message)) || strings.error || 'Noe gikk galt');
          throw err;
        });
    },

    change: function (line, quantity) {
      return fetchJSON((routes.cartChange || '/cart/change') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function () {
        return Cart.refresh();
      });
    },

    updateAttributes: function (attributes) {
      return fetchJSON((routes.cartUpdate || '/cart/update') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attributes })
      });
    },

    /* Pull a fresh drawer render from the section rendering API */
    refresh: function () {
      return fetch((routes.cart || '/cart') + '?section_id=cart-drawer')
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = $('[data-cart-drawer-contents]', doc);
          var current = $('[data-cart-drawer-contents]');
          if (fresh && current) current.innerHTML = fresh.innerHTML;

          var countSource = $('[data-cart-count]', doc);
          $$('[data-cart-count]').forEach(function (el) {
            if (!countSource) return;
            var n = countSource.textContent.trim();
            el.textContent = n;
            el.hidden = n === '0' || n === '';
            el.classList.remove('pop');
            void el.offsetWidth;
            el.classList.add('pop');
          });

          /* keep the full cart page in sync when it is open */
          if (document.body.classList.contains('template-cart')) {
            window.location.reload();
          }
          return true;
        });
    }
  };

  /* ---------- add-to-cart forms (cards + product page) ---------- */

  function bindAddForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-add-form]');
      if (!form) return;
      e.preventDefault();

      var btn = $('[type="submit"]', form);
      var original = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = strings.adding || 'Legger til …'; }

      var qty = parseInt((form.querySelector('[name="quantity"]') || {}).value || 1, 10);
      var variantId = (form.querySelector('[name="id"]') || {}).value;

      var properties = {};
      $$('[data-property]', form).forEach(function (input) {
        var key = input.getAttribute('data-property');
        if (input.type === 'checkbox') {
          if (!input.checked) return;
          properties[key] = properties[key] ? properties[key] + ', ' + input.value : input.value;
        } else if (input.type === 'radio') {
          if (input.checked && input.value) properties[key] = input.value;
        } else if (input.value) {
          properties[key] = input.value;
        }
      });

      var items = [{ id: variantId, quantity: qty, properties: properties }];

      /* paid add-ons are added as their own lines, tagged to this dish */
      $$('[data-addon]:checked', form).forEach(function (input) {
        items.push({
          id: input.value,
          quantity: qty,
          properties: { '_til': form.getAttribute('data-product-title') || '' }
        });
      });

      Cart.add(items, { openDrawer: form.getAttribute('data-open-drawer') !== 'false' })
        .then(function () {
          if (btn) {
            btn.classList.add('is-added');
            btn.innerHTML = strings.added || 'I kurven';
            setTimeout(function () {
              btn.classList.remove('is-added');
              btn.innerHTML = original;
              btn.disabled = false;
            }, 1200);
          }
        })
        .catch(function () {
          if (btn) { btn.innerHTML = original; btn.disabled = false; }
        });
    });
  }

  /* ---------- product page: variants + running price ---------- */

  function initProductForm(root) {
    var form = $('[data-product-form]', root) || $('[data-product-form]');
    if (!form) return;

    var dataEl = $('[data-product-json]', form.closest('[data-product-root]') || document);
    if (!dataEl) return;

    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var idInput = $('[name="id"]', form);
    var priceEl = $('[data-product-price]');
    var compareEl = $('[data-product-compare]');
    var submitBtn = $('[type="submit"]', form);

    function currentOptions() {
      return $$('[data-option-index]', form)
        .filter(function (input) { return input.checked || input.tagName === 'SELECT'; })
        .map(function (input) { return input.value; });
    }

    function matchVariant() {
      var selected = currentOptions();
      return product.variants.filter(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      })[0];
    }

    function addonTotal() {
      return $$('[data-addon]:checked', form).reduce(function (sum, el) {
        return sum + (parseInt(el.getAttribute('data-addon-price'), 10) || 0);
      }, 0);
    }

    function render() {
      var variant = matchVariant();
      if (!variant) {
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = strings.unavailable || 'Ikke tilgjengelig';
        }
        return;
      }
      if (idInput) idInput.value = variant.id;

      var qty = parseInt((form.querySelector('[name="quantity"]') || {}).value || 1, 10);
      var total = (variant.price + addonTotal()) * qty;

      if (priceEl) priceEl.textContent = formatMoney(total);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price * qty);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.textContent = variant.available
          ? (strings.addToCart || 'Legg i kurven')
          : (strings.soldOut || 'Utsolgt');
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    form.addEventListener('change', render);
    form.addEventListener('input', function (e) {
      if (e.target.name === 'quantity') render();
    });
    render();
  }

  /* ---------- quantity steppers ---------- */

  function bindQuantity() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-change]');
      if (!btn) return;
      e.preventDefault();
      var input = $('[name="quantity"]', btn.closest('[data-qty-wrap]'));
      if (!input) return;
      var next = parseInt(input.value, 10) + parseInt(btn.getAttribute('data-qty-change'), 10);
      input.value = Math.max(1, next);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---------- gallery ---------- */

  function bindGallery() {
    document.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-gallery-thumb]');
      if (!thumb) return;
      var wrap = thumb.closest('[data-gallery]');
      var main = $('[data-gallery-main]', wrap);
      if (main) {
        main.src = thumb.getAttribute('data-full');
        main.srcset = '';
        main.alt = thumb.getAttribute('data-alt') || '';
      }
      $$('[data-gallery-thumb]', wrap).forEach(function (t) { t.setAttribute('aria-current', 'false'); });
      thumb.setAttribute('aria-current', 'true');
    });
  }

  /* ---------- hero rotator ---------- */

  function initHero() {
    var hero = $('[data-hero]');
    if (!hero) return;

    var slides;
    try { slides = JSON.parse($('[data-hero-slides]', hero).textContent); } catch (err) { return; }
    if (!slides.length) return;

    var imgEl = $('[data-hero-image]', hero);
    var wordEl = $('[data-hero-word]', hero);
    var noteEl = $('[data-hero-note]', hero);
    var dots = $$('[data-hero-dot]', hero);
    var index = 0;
    var timer;
    var paused = false;

    function show(i) {
      index = (i + slides.length) % slides.length;
      var slide = slides[index];
      if (imgEl && slide.image) {
        imgEl.src = slide.image;
        imgEl.alt = slide.alt || '';
        imgEl.style.animation = 'none';
        void imgEl.offsetWidth;
        imgEl.style.animation = '';
      }
      if (wordEl && slide.word) {
        wordEl.textContent = slide.word;
        wordEl.style.animation = 'none';
        void wordEl.offsetWidth;
        wordEl.style.animation = '';
      }
      if (noteEl) noteEl.textContent = slide.note || '';
      dots.forEach(function (d, di) { d.setAttribute('aria-selected', di === index ? 'true' : 'false'); });
    }

    function start() {
      clearInterval(timer);
      timer = setInterval(function () { if (!paused) show(index + 1); }, 3600);
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { show(i); start(); });
    });

    var stage = $('[data-hero-stage]', hero);
    if (stage) {
      stage.addEventListener('mouseenter', function () { paused = true; });
      stage.addEventListener('mouseleave', function () { paused = false; });
    }

    /* subtle tilt on the plate */
    var plate = $('[data-hero-plate]', hero);
    if (plate && window.matchMedia('(hover: hover)').matches) {
      var frame;
      hero.addEventListener('mousemove', function (e) {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(function () {
          var r = hero.getBoundingClientRect();
          var x = ((e.clientX - r.left) / r.width - 0.5) * 14;
          var y = ((e.clientY - r.top) / r.height - 0.5) * -10;
          plate.style.transform = 'rotateY(' + x + 'deg) rotateX(' + y + 'deg)';
        });
      });
      hero.addEventListener('mouseleave', function () {
        plate.style.transform = '';
      });
    }

    show(0);
    start();
  }

  /* ---------- scroll reveal ---------- */

  function initReveal() {
    var items = $$('.reveal:not(.is-in)');
    if (!items.length || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          obs.unobserve(entry.target);
        }
      });
    }, { rootMargin: '120px' });
    items.forEach(function (el) { obs.observe(el); });
  }

  /* ---------- cart note (drawer) ---------- */

  function bindCartNote() {
    var noteTimer;
    document.addEventListener('input', function (e) {
      var field = e.target.closest('[data-cart-note]');
      if (!field) return;
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () {
        fetch((routes.cartUpdate || '/cart/update') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: field.value })
        });
      }, 600);
    });
  }

  /* ---------- order type: ta med / spis her ---------- */

  function initOrderType() {
    var groups = $$('[data-order-type]');
    if (!groups.length) return;

    groups.forEach(function (group) {
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('button[data-value]');
        if (!btn) return;
        var value = btn.getAttribute('data-value');
        groups.forEach(function (g) {
          $$('button[data-value]', g).forEach(function (b) {
            b.setAttribute('aria-pressed', b.getAttribute('data-value') === value ? 'true' : 'false');
          });
        });
        try { localStorage.setItem('jafs-order-type', value); } catch (err) {}
        Cart.updateAttributes({ 'Servering': value });
      });
    });

    var saved;
    try { saved = localStorage.getItem('jafs-order-type'); } catch (err) {}
    if (saved) {
      groups.forEach(function (g) {
        $$('button[data-value]', g).forEach(function (b) {
          b.setAttribute('aria-pressed', b.getAttribute('data-value') === saved ? 'true' : 'false');
        });
      });
    }
  }

  /* ---------- live menu filter on the collection page ---------- */

  function initMenuFilter() {
    var input = $('[data-menu-filter]');
    if (!input) return;
    var cards = $$('[data-filter-name]');
    var empty = $('[data-filter-empty]');

    function run() {
      var q = input.value.trim().toLowerCase();
      var hits = 0;
      cards.forEach(function (card) {
        var haystack = card.getAttribute('data-filter-name').toLowerCase();
        var match = !q || haystack.indexOf(q) !== -1;
        card.hidden = !match;
        if (match) hits++;
      });
      if (empty) empty.hidden = hits !== 0;
    }

    input.addEventListener('input', run);
    var clear = $('[data-menu-filter-clear]');
    if (clear) {
      clear.addEventListener('click', function () {
        input.value = '';
        run();
        input.focus();
      });
    }
  }

  /* ---------- opening hours status ---------- */

  function initOpenStatus() {
    $$('[data-open-status]').forEach(function (el) {
      var config;
      try { config = JSON.parse(el.getAttribute('data-open-status')); } catch (err) { return; }
      if (!config) return;
      var now = new Date();
      var day = now.getDay(); // 0 = Sunday
      var isWeekend = day === 0 || day === 6;
      var open = isWeekend ? config.weekendOpen : config.weekdayOpen;
      var close = isWeekend ? config.weekendClose : config.weekdayClose;
      var minutes = now.getHours() * 60 + now.getMinutes();

      function toMinutes(t) {
        var parts = String(t || '').split(':');
        return (parseInt(parts[0], 10) || 0) * 60 + (parseInt(parts[1], 10) || 0);
      }

      var isOpen = minutes >= toMinutes(open) && minutes < toMinutes(close);
      var dot = $('.dot', el);
      var label = $('[data-open-label]', el);

      el.classList.toggle('pill--open', isOpen);
      if (dot) dot.classList.toggle('dot--live', isOpen);
      if (label) {
        label.textContent = isOpen
          ? (config.openLabel || 'Åpent nå').replace('{time}', close)
          : (config.closedLabel || 'Stengt').replace('{time}', open);
      }
    });
  }

  /* ---------- boot ---------- */

  function boot() {
    Drawer.init();
    bindAddForms();
    bindQuantity();
    bindGallery();
    bindCartNote();
    initHero();
    initReveal();
    initOrderType();
    initMenuFilter();
    initOpenStatus();
    initProductForm(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* re-run when the theme editor swaps a section */
  document.addEventListener('shopify:section:load', function (e) {
    initHero();
    initReveal();
    initOpenStatus();
    initProductForm(e.target);
    initMenuFilter();
    initOrderType();
  });

  window.JafsTheme = { Cart: Cart, Drawer: Drawer, toast: toast, formatMoney: formatMoney };
})();
